import State from 'store/State';
import { WidgetInfo } from 'widgets/WidgetInfo';
import { AnyConfig } from 'widgets/WidgetRegistry';
import { UIComponentConfiguration } from 'communication/types/uiConfiguration/UIConfiguration';
import { WidgetsService } from 'widgets/WidgetsService';
import WidgetsState, {
    WidgetInstancesState,
    WidgetsDataState,
} from './WidgetsState';
import { WidgetType } from 'widgets/WidgetType';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import { WidgetId } from 'widgets/WidgetId';

export const selectWidgetsState: (state: State) => WidgetsState = (state) =>
    state.widgets;

export const selectWidgetsDataState: (state: State) => WidgetsDataState = (
    state
) => state.widgets.data;

export const selectWidgetInstancesState: (
    state: State
) => WidgetInstancesState = (state) => state.widgets.instances;

export const selectWidgetInstanceState = (
    state: State,
    widgetType: WidgetType,
    widgetKey: string
) => {
    const widgetInstancesState = selectWidgetInstancesState(state)[
        widgetType
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ] as any;
    if (widgetInstancesState) {
        return widgetInstancesState[widgetKey];
    }
    return undefined;
};

export const selectWidgetInstanceConfig = (state: State, id: WidgetId) =>
    selectWidgetInstanceState(state, id.widgetType, id.widgetKey)?.config;

export const selectWidgetConfigState: (
    state: State,
    component: WidgetInfo,
    widgetsService: WidgetsService
) => AnyConfig | undefined = (state, component, widgetsService) => {
    const instanceState = selectWidgetInstanceState(
        state,
        component.type,
        component.id
    ) as WidgetWithConfigState<AnyConfig> | undefined;

    if (instanceState?.config) {
        return instanceState?.config;
    }

    return widgetsService.getInitialConfigState<AnyConfig>(component.type);
};

export const selectWidgetComponentConfigs: (
    state: State,
    components: WidgetInfo[],
    widgetsService: WidgetsService
) => { [key: string]: UIComponentConfiguration } = (
    state,
    components,
    widgetsService
) => {
    const ret: { [key: string]: UIComponentConfiguration } = {};

    for (const component of components) {
        const config = selectWidgetConfigState(
            state,
            component,
            widgetsService
        );
        if (config) {
            ret[component.id] = {
                type: component.type,
                ...config,
            };
        }
    }
    return ret;
};
